import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ApiListResponseModel, ApiService } from "../core";
import {
  ImportedTransactionDetailDto,
  ImportedTransactionGetDto,
  ImportedTransactionGridRequestDto
} from "../dto";

@Injectable()
export class ImportedTransactionService {
  protected serviceUrl = "imported/transactions";

  constructor(protected api: ApiService) {}

  getList(request: ImportedTransactionGridRequestDto): Observable<ApiListResponseModel<ImportedTransactionGetDto[]>> {
    return this.api.postList(this.serviceUrl, request);
  }

  getById(id: string): Observable<ImportedTransactionDetailDto> {
    return this.api.get<ImportedTransactionDetailDto>(`${this.serviceUrl}/${id}`);
  }
}
